<template>
    <div>
        <template v-if="scenario == 'cstudent'">
            <a-tabs type="card" @change="changeCstudent" :default-active-key="active" v-if="csid > 0">
                <a-tab-pane key="info" tab="学员信息"></a-tab-pane>
                <a-tab-pane key="lesson" tab="课程列表"></a-tab-pane>
                <a-tab-pane key="study" tab="学习记录"></a-tab-pane>
            </a-tabs>
        </template>

        <template v-if="scenario == 'clesson'">
            <a-tabs type="card" @change="changeClesson" :default-active-key="active" v-if="clid > 0">
                <a-tab-pane key="info" tab="课程信息"></a-tab-pane>
                <a-tab-pane key="study" tab="学习记录"></a-tab-pane>
            </a-tabs>
        </template>

        <template v-if="scenario == 'class'">
            <a-tabs type="card" @change="changeClass" :default-active-key="active" v-if="cbid > 0">
                <a-tab-pane key="info" tab="班级信息"></a-tab-pane>
                <a-tab-pane key="student" tab="学员列表"></a-tab-pane>
                <a-tab-pane key="lesson" tab="课程列表"></a-tab-pane>
            </a-tabs>
        </template>

        <template v-if="scenario == 'college'">
            <a-tabs type="card" @change="changeCollege" :default-active-key="active" v-if="scid > 0">
                <a-tab-pane key="info" tab="学院信息"></a-tab-pane>
                <a-tab-pane key="student" tab="学生列表"></a-tab-pane>
            </a-tabs>
        </template>

        <template v-if="scenario == 'school'">
            <a-tabs type="card" @change="changeSchool" :default-active-key="active" v-if="sid > 0">
                <a-tab-pane key="info" tab="学校信息"></a-tab-pane>
                <a-tab-pane key="college" tab="学院列表"></a-tab-pane>
                <a-tab-pane key="student" tab="学生列表"></a-tab-pane>
            </a-tabs>
        </template>

        <template v-if="scenario == 'lmodule'">
            <a-tabs type="card" @change="changeLmodule" :default-active-key="active" v-if="lmid > 0">
                <a-tab-pane key="info" tab="模块信息"></a-tab-pane>
                <a-tab-pane key="chapter" tab="课程列表"></a-tab-pane>
            </a-tabs>
        </template>

        <template v-if="scenario == 'lesson'">
            <a-tabs type="card" @change="changeLesson" :default-active-key="active" v-if="lid > 0">
                <a-tab-pane key="info" tab="课程库信息"></a-tab-pane>
                <a-tab-pane key="module" tab="模块列表"></a-tab-pane>
                <a-tab-pane key="chapter" tab="课程列表"></a-tab-pane>
            </a-tabs>
        </template>

        <template v-if="scenario == 'resume'">
            <a-tabs type="card" @change="changeResume" :default-active-key="active" v-if="rid > 0">
                <a-tab-pane key="info" tab="简历信息"></a-tab-pane>
                <a-tab-pane key="visit" tab="拜访记录"></a-tab-pane>
                <a-tab-pane key="manager" tab="分配记录"></a-tab-pane>
            </a-tabs>
        </template>

        <template v-if="scenario == 'psi'">
            <a-tabs type="card" @change="changePsi" :default-active-key="active" v-if="pid > 0">
                <a-tab-pane key="info" tab="货物信息"></a-tab-pane>
                <a-tab-pane key="log" tab="库存信息"></a-tab-pane>
            </a-tabs>
        </template>

        <template v-if="scenario == 'enterprise'">
            <a-tabs type="card" @change="changeEnterprise" :default-active-key="active" v-if="eid > 0">
                <a-tab-pane key="info" tab="基本信息"></a-tab-pane>
                <a-tab-pane key="contract" tab="合同信息"></a-tab-pane>
                <a-tab-pane key="job" tab="职位信息"></a-tab-pane>
                <a-tab-pane key="sabill" tab="工资账单"></a-tab-pane>
            </a-tabs>
        </template>

        <template v-if="scenario == 'job'">
            <a-tabs type="card" @change="changeJob" :default-active-key="active" v-if="jid > 0">
                <a-tab-pane key="info" tab="职位信息"></a-tab-pane>
                <a-tab-pane key="employee" tab="员工列表"></a-tab-pane>
            </a-tabs>
        </template>

        <template v-if="scenario == 'employee'">
            <a-tabs type="card" @change="changeEmployee" :default-active-key="active" v-if="empid > 0">
                <a-tab-pane key="info" tab="员工信息"></a-tab-pane>
                <a-tab-pane key="contract" tab="合同信息"></a-tab-pane>
                <a-tab-pane key="salary" tab="工资列表"></a-tab-pane>
            </a-tabs>
        </template>
    </div>
</template>

<script>
export default {
    props: {
        scenario: {
            type: [String],
            default: '',
        },
        csid: {
            type: String,
            default: '',
        },
        clid: {
            type: String,
            default: '',
        },
        cbid: {
            type: String,
            default: '',
        },
        sid: {
            type: String,
            default: '',
        },
        scid: {
            type: String,
            default: '',
        },
        lid: {
            type: String,
            default: '',
        },
        lmid: {
            type: String,
            default: '',
        },
        rid: {
            type: String,
            default: '',
        },
        pid: {
            type: String,
            default: '',
        },
        eid: {
            type: String,
            default: '',
        },
        jid: {
            type: String,
            default: '',
        },
        empid: {
            type: String,
            default: '',
        },
        active: {
            type: String,
            default: '',
        },
    },
    watch: {
    },
    data() {
        return {

        };
    },
    created() {

    },
    methods: {
        // 操作
        optionFun(op) {
            this.$emit('optionFun', {scenario: this.scenario, op: op});
        },
        changeCstudent(key) {
            switch (key) {
                case 'info':
                    this.$router.replace('/cstudent/edit?cbid=' + this.cbid + '&csid=' + this.csid);
                    break;
                case 'lesson':
                    this.$router.replace('/clesson/student?cbid=' + this.cbid + '&csid=' + this.csid);
                    break;
                case 'study':
                    this.$router.replace('/study/list?cbid=' + this.cbid + '&csid=' + this.csid);
                    break;
                default:
                    break;
            }
        },
        changeClesson(key) {
            switch (key) {
                case 'info':
                    this.$router.replace('/clesson/edit?clid=' + this.clid);
                    break;
                case 'study':
                    this.$router.replace('/study/list?clid=' + this.clid);
                    break;
                default:
                    break;
            }
        },
        changeClass(key) {
            switch (key) {
                case 'info':
                    this.$router.replace('/class/edit?cbid=' + this.cbid);
                    break;
                case 'student':
                    this.$router.replace('/cstudent/list?cbid=' + this.cbid);
                    break;
                case 'lesson':
                    this.$router.replace('/clesson/list?cbid=' + this.cbid);
                    break;
                default:
                    break;
            }
        },
        changeCollege(key) {
            switch (key) {
                case 'info':
                    this.$router.replace('/college/edit?scid=' + this.scid);
                    break;
                case 'student':
                    this.$router.replace('/student/list?scid=' + this.scid);
                    break;
                default:
                    break;
            }
        },
        changeSchool(key) {
            switch (key) {
                case 'info':
                    this.$router.replace('/school/edit?sid=' + this.sid);
                    break;
                case 'college':
                    this.$router.replace('/college/list?sid=' + this.sid);
                    break;
                case 'student':
                    this.$router.replace('/student/list?sid=' + this.sid);
                    break;
                default:
                    break;
            }
        },
        changeLmodule(key) {
            switch (key) {
                case 'info':
                    this.$router.replace('/lmodule/edit?lmid=' + this.lmid);
                    break;
                case 'chapter':
                    this.$router.replace('/lchapter/list?lmid=' + this.lmid);
                    break;
                default:
                    break;
            }
        },
        changeLesson(key) {
            switch (key) {
                case 'info':
                    this.$router.replace('/lesson/edit?lid=' + this.lid);
                    break;
                case 'module':
                    this.$router.replace('/lmodule/list?lid=' + this.lid);
                    break;
                case 'chapter':
                    this.$router.replace('/lchapter/list?lid=' + this.lid);
                    break;
                default:
                    break;
            }
        },
        changeResume(key) {
            switch (key) {
                case 'info':
                    this.$router.replace('/resume/edit?rid=' + this.rid);
                    break;
                case 'visit':
                    this.$router.replace('/resume/visit?rid=' + this.rid);
                    break;
                case 'manager':
                    this.$router.replace('/resume/manager?rid=' + this.rid);
                    break;
                default:
                    break;
            }
        },
        changePsi(key) {
            switch (key) {
                case 'info':
                    this.$router.replace('/psi/edit?pid=' + this.pid);
                    break;
                case 'log':
                    this.$router.replace('/psi/log-list?pid=' + this.pid);
                    break;
                default:
                    break;
            }
        },
        changeEnterprise(key) {
            switch (key) {
                case 'info':
                    this.$router.replace('/enterprise/edit?eid=' + this.eid);
                    break;
                case 'contract':
                    this.$router.replace('/entercontract/list?eid=' + this.eid);
                    break;
                case 'job':
                    this.$router.replace('/job/list?eid=' + this.eid);
                    break;
                case 'sabill':
                    this.$router.replace('/sabill/list?eid=' + this.eid);
                    break;
                default:
                    break;
            }
        },
        changeJob(key) {
            switch (key) {
                case 'info':
                    this.$router.replace('/job/edit?jid=' + this.jid);
                    break;
                case 'employee':
                    this.$router.replace('/employee/list?jid=' + this.jid);
                    break;
                default:
                    break;
            }
        },
        changeEmployee(key) {
            switch (key) {
                case 'info':
                    this.$router.replace('/employee/edit?empid=' + this.empid);
                    break;
                case 'contract':
                    this.$router.replace('/empcontract/list?empid=' + this.empid);
                    break;
                case 'salary':
                    this.$router.replace('/salary/list?empid=' + this.empid);
                    break;
                default:
                    break;
            }
        },
    }
}
</script>
